// Slow Objet: click-to-open header menus (Horizon desktop mega menu).
(function () {
  var HOVER = ['pointerenter', 'pointermove', 'focus', 'focusin'];
  var OUT = ['pointerleave', 'blur', 'focusout'];
  function isMore(el) {
    return !!(el && el.closest && el.closest(`[slot='more']`));
  }
  function patch(menu) {
    if (!menu || menu.__soPatched) return;
    if (typeof menu.activate !== 'function' || typeof menu.deactivate !== 'function') return;
    menu.__soPatched = true;
    var origA = menu.activate.bind(menu);
    var origD = menu.deactivate.bind(menu);
    menu.activate = function (e) {
      if (e && HOVER.indexOf(e.type) !== -1 && !isMore(e.target)) return;
      return origA(e);
    };
    menu.deactivate = function (e) {
      if (e && OUT.indexOf(e.type) !== -1 && !isMore(e.target)) return;
      return origD(e);
    };
    menu.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || isMore(t)) return;
      var link = t.closest(`[ref='menuitem']`);
      if (!link) return;
      var li = link.closest(`.menu-list__list-item`);
      var sub = li && li.querySelector(`:scope > .menu-list__submenu`);
      if (!sub) return;
      e.preventDefault();
      if (link.getAttribute('aria-expanded') === 'true') {
        menu.deactivate({ type: 'click', target: menu });
      } else {
        menu.activate({ type: 'click', target: li });
      }
    });
    document.addEventListener('click', function (e) {
      if (menu.getAttribute('aria-expanded') !== 'true') return;
      if (e.target && menu.contains(e.target)) return;
      menu.deactivate({ type: 'click', target: menu });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') menu.deactivate({ type: 'click', target: menu });
    });
  }
  function boot() {
    var menus = document.querySelectorAll('header-menu');
    for (var i = 0; i < menus.length; i++) patch(menus[i]);
    return menus.length > 0;
  }
  function start() {
    if (boot()) return;
    var root = document.querySelector('#header-component') || document.body;
    var mo = new MutationObserver(function () { if (boot()) mo.disconnect(); });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 6000);
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-menu').then(start);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
